"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSendStatus = exports.default = void 0;

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _Localize = _interopRequireWildcard(require("../Localization/Localize"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _Constants$ActivityCl = _botframeworkWebchatCore.Constants.ActivityClientState,
    SEND_FAILED = _Constants$ActivityCl.SEND_FAILED,
    SENDING = _Constants$ActivityCl.SENDING;

var connectSendStatus = function connectSendStatus() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var focusSendBox = _ref.focusSendBox,
        language = _ref.language,
        postActivity = _ref.postActivity;
    var activity = _ref2.activity;
    return {
      language: language,
      retrySend: function retrySend(evt) {
        evt.preventDefault();
        postActivity(activity); // After clicking on "retry", the button will be gone and focus will be lost (back to document.body)
        // We want to make sure the user stay inside Web Chat

        focusSendBox();
      }
    };
  }].concat(selectors));
};

exports.connectSendStatus = connectSendStatus;

var SendStatus = function SendStatus(_ref3) {
  var _ref3$activity$channe = _ref3.activity.channelData;
  _ref3$activity$channe = _ref3$activity$channe === void 0 ? {} : _ref3$activity$channe;
  var state = _ref3$activity$channe.state,
      language = _ref3.language,
      retrySend = _ref3.retrySend,
      styleSet = _ref3.styleSet; // TODO: [P4] Currently, this is the only place which use a templated string
  //       We could refactor this into a general component if there are more templated strings

  var sendFailedText = (0, _Localize.localize)('SEND_FAILED_KEY', language);
  var sendFailedRetryMatch = /\{Retry\}/.exec(sendFailedText);
  return _react.default.createElement("span", {
    className: styleSet.sendStatus
  }, state === SENDING ? _react.default.createElement(_Localize.default, {
    text: "Sending"
  }) : state === SEND_FAILED ? sendFailedRetryMatch ? _react.default.createElement(_react.default.Fragment, null, sendFailedText.substr(0, sendFailedRetryMatch.index), _react.default.createElement("button", {
    onClick: retrySend,
    type: "button"
  }, (0, _Localize.localize)('Retry', language)), sendFailedText.substr(sendFailedRetryMatch.index + sendFailedRetryMatch[0].length)) : _react.default.createElement("button", {
    onClick: retrySend,
    type: "button"
  }, sendFailedText) : false);
};

SendStatus.propTypes = {
  activity: _propTypes.default.shape({
    channelData: _propTypes.default.shape({
      state: _propTypes.default.string
    })
  }).isRequired,
  language: _propTypes.default.string.isRequired,
  retrySend: _propTypes.default.func.isRequired,
  styleSet: _propTypes.default.shape({
    sendStatus: _propTypes.default.any.isRequired
  }).isRequired
};

var _default = connectSendStatus(function (_ref4) {
  var styleSet = _ref4.styleSet;
  return {
    styleSet: styleSet
  };
})(SendStatus);

exports.default = _default;